import { connect } from 'react-redux'
import newsButton from '../ui/buttons/newsButton'
import { setNews } from '../../store/actions/newsActions'

const mapStateToProps = state => ({
    news: state.news
})

const mapDispatchToProps = dispatch => {
    return {
        newsToState: (val) => {
            dispatch(
                setNews(val)
            )
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(newsButton)